import React from 'react';

export default function VvDecor(props) {
    return <div className={`decor ${props.className || 'main-decor'}`}><img src="/images/star.png" alt="" /></div>;
}